<template>
  <footer class="q4cl-fixed-fontsize bg-white border-t border-q4cl-border mt-8 no-print">
    <div class="w-full max-w-5xl mx-auto px-4 py-5 text-xs text-q4cl-muted flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
      <div>
        <span class="font-medium text-q4cl-primary">EMUYN</span> {{ $t('セキュア問診票') }}
      </div>
      <div>
        <a href="https://www.emuyn.net/" target="_blank" rel="noopener" class="link-inline">{{ $t('エミュイン合同会社') }}</a>
        <span class="mx-2" aria-hidden="true">·</span>
        <a href="https://www.emuyn.net/q4cl/inquiry" target="_blank" rel="noopener" class="link-inline">{{ $t('お問合せ') }}</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default { name: 'AppFooter' };
</script>
